export default __webpack_public_path__ + "static/media/contact2.34374fef.jpg";